angular.module('qkr')
    .factory('sessionExpiryEventService', sessionExpiryEventService);
sessionExpiryEventService.$inject = ['$timeout', 'appConfig'];

function sessionExpiryEventService($timeout, appConfig) {
    /**
     *  This is our pub / sub service that will handle all invocations of the modal callback created in the
     *  'run' section of our application in 'main.js'
     */

    const subscribers = [];

    let sessionExpiryTimer = null;
    let enabled = true; // TODO why hold this state, can we not just clear subscribers array to disable?

    return {

        /**
         *  Once a user has logged in they have a limit to the amount of time they can stay inactive. Inactivity
         *  in this case is determined by the last time they pinged our server. If a new request is made while a
         *  timer is running, then the running timer is cleared and we start the timer again.
         */
        refreshSessionTimeout() {
            if (enabled) {
                $timeout.cancel(sessionExpiryTimer);

                sessionExpiryTimer = $timeout(() => {
                    enabled = false;
                    subscribers.forEach(s => s());
                }, appConfig.sessionTimeoutMillis);
            }
        },

        addSubscriber(callback) {
            subscribers.push(callback);
        }
    };
}





// WEBPACK FOOTER //
// ./src/sessionExpiry/services/session.expiry.event.services.js